<template>
  <div class="loginFormContainer" :style="{height:codeIsShow?'520px':'460px'}">
    <div class="login_bg" :style="{height:codeIsShow?'520px':'460px'}"></div>
    <div class="login_container" :style="{height:codeIsShow?'520px':'460px'}">
      <div class="loginTitle"><span>{{sysName}}</span></div>
      <el-form
        class="loginForm"
        ref="loginForm"
        :model="userInfo"
        :rules="rules"
        :label-position="labelPosition"
      >
        <h1 class="welcome-text">欢迎登录</h1>
        <el-form-item prop="userName">
          <el-input v-model="userInfo.userName" placeholder="请输入用户名" @blur="blurPrice">
            <i class="inputIcon" slot="prefix">
              <img src="../../assets/img/homePage/login_user.png" alt />
            </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="pwd">
          <el-input v-model="userInfo.pwd" placeholder="请输入密码" type="password" show-password>
            <i class="inputIcon" slot="prefix">
              <img src="../../assets/img/homePage/login_pwd.png" alt />
            </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="code" v-if="codeIsShow">
          <el-input class="codeInput" v-model="userInfo.code" placeholder="请输入验证码">
            <i class="inputIcon" slot="prefix">
              <img src="../../assets/img/homePage/login_code.png" alt />
            </i>
          </el-input>
          <div class="codeImg" @click="refreshCode">
            <img :src="codeImg" alt />
          </div>
        </el-form-item>
        <el-form-item>
          <el-button class="loginBtn" @click="login('loginForm')" :loading="logining">登 录</el-button>
        </el-form-item>
        <el-form-item class="rememberMe">
          <div class="tip-box">
            <el-checkbox v-model="checked">
              <span class="tip">已阅读并同意</span></el-checkbox><span class="yinsi" @click="handleAgree">《用户隐私协议》</span>
          </div>
          <!-- <el-checkbox v-model="userInfo.rememberMe" name="rememberMe" @change="rempwd">记住登录状态</el-checkbox> -->
        </el-form-item>
        <el-form-item>
          <div class="forget" @click="handleFindpaw">
            忘记密码?
          </div>
        </el-form-item>
      </el-form>
      <!-- <div class="tip-box">
        <el-checkbox v-model="checked">
          <span class="tip">已阅读并同意《用户隐私协议》</span></el-checkbox>
      </div> -->
      <div class="erweima" @click="handleSaoma">
        <img src="../../assets/img/login/erweima.png" alt="">
      </div>
    </div>
    <el-dialog
      class="selfDialog"
      :visible.sync="showUrlEwm"
      @closed="handleClosedErweima"
      width="550px"
      :show-close="false">
      <img src="../../assets/img/login/bigErweima.png" alt="" v-if="showUrlEwm">
    </el-dialog>
    <el-dialog
      class="selfDialog"
      :visible.sync="dialogVisible"
      @closed="handleClosed"
      width="550px"
      :close-on-click-modal="false">
      <!-- <img src="../../assets/img/login/bigErweima.png" alt="" v-if="showUrlEwm"> -->
      <div class="findPaw" v-if="showUrlEwm1">
        <div class="title">
          <h1>找回密码</h1>
        </div>
        <div class="title1">请输入您的用户账号和手机号码:</div>
        <div class="dialogForm">
          <el-input v-model="dialogData.username" placeholder="请输入用户账户"></el-input>
          <el-input v-model="dialogData.phone" placeholder="请输入手机号码"></el-input>
        </div>
        <div class="buttonNext">
          <el-button type="primary" :loading="nextLoading" @click="handleNext">下一步</el-button>
        </div>
      </div>
      <div class="findPaw1" v-if="showUrlEwm2">
        <div class="title">
          <h1>重置密码</h1>
        </div>
        <div class="title1">验证码已发送至<span style="color: #06CAE1">{{dialogData.phone}}</span>:</div>
        <div class="duanxinYzm">
          <div class="yanzhengma">
            <el-input v-model="subData.code" placeholder="请输入短信验证码"></el-input>
          </div>
          <div class="daojishi" v-if="showyzm">重新发送（{{second}}）</div>
          <div class="daojishi" v-else @click="handleAgain" style="cursor: pointer;">重新发送</div>
        </div>
        <div class="dialogForm">
          <el-input v-model="subData.pwd" placeholder="请输入新密码" show-password></el-input>
          <el-input v-model="subData.pwd1" placeholder="请再次输入新密码" show-password></el-input>
        </div>
        <div class="buttonNext">
          <el-button type="primary" :loading="enitPwdLoading" @click="handleEnitPwd">提交</el-button>
        </div>
      </div>
    </el-dialog>
    <yin-si ref="yin" :showYinsi.sync="showYinsi" :isRead="isRead" @handleAgreed="handleAgreed" :isSetShow="true" />
  </div>
</template>

<script>
var md5 = require("js-md5");
var base64 = require("js-base64").Base64;
import { textPassword } from '@/utils/validate'
import yinSi from './yinSi.vue'
export default {
  components:{ yinSi },
  data() {
    return {
      showYinsi: false,
      checked: false,
      isRead: true,
      dialogVisible: false, // 二维码弹窗
      second: '', // 倒计时
      showyzm: true, // 显示隐藏
      showUrlEwm: false,
      showUrlEwm1: false,
      showUrlEwm2: false,
      dialogData: {
        username: '',
        phone: '',
      },
      subData: {
        code: '',
        phone: '',
        pwd: '',
        pwd1: '',
        authId: '',
        username: '',
      },
      labelPosition: "right",
      userInfo: {
        userName: "",
        pwd: "",
        code: "",
        rememberMe: false,
      },
      cookieUser: "",
      cookiePwd: "",
      codeIsShow: false,
      codeImg: "",
      rememberActive: true,
      rules: {
        userName: [{ validator: this.validateUserName, trigger: "blur" }],
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 32,
            message: "长度在 6 到 32 个字符",
            trigger: "blur",
          },
        ],
      },
      logining: false,
      nextLoading: false,
      enitPwdLoading: false,
      sysName:'',
      timmer: null
    }
  },
  created() {
    this.resetSetItem('alarmList', null)
    this.getSysName()
    this.checkCode();
    // this.getCookie();
    var lett = this;
    // var user = this.$cookies.get("user");
    // console.log(user);
    // if (user != null) {
    //   var up = base64.decode(user);
    //   var aa = up.split("-");
    //   this.cookieUser = aa[0];
    //   this.cookiePwd = aa[1];
    //   // this.userInfo.userName = aa[0];
    //   // this.userInfo.pwd = aa[1];

    // }
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        lett.login('loginForm');
      }
    };
  },
  //页面加载调用获取cookie值
  mounted() {
    this.userInfo.rememberMe = false
   //  console.log(this.cookieUser)
   //  console.log(this.cookiePwd)
/*    if(this.userInfo.userName!=this.cookieUser){
      
   }else{
      this.userInfo.rememberMe=true
   } */
   
  },
  methods: {
    handleAgree () {
      this.showYinsi = true
      this.isRead = true
      this.$nextTick(() => {
        const dom = this.$refs.yin.$refs.yinsi
        // const dom = this.$refs.yinsi
        console.log(this.$refs.yin.$refs.yinsi)
        dom.addEventListener('scroll', () => {
          if (dom.scrollTop + dom.clientHeight >= dom.scrollHeight - 1) {
            this.isRead = false
          }
        })
      })
    },
    handleAgreed () {
      this.showYinsi = false
      this.checked = true
    },
    // 点击打开关注公众号步骤
    handleSaoma () {
      // this.dialogVisible = true
      this.showUrlEwm = true
      this.dialogVisible = false
      // this.showUrlEwm1 = false
      // this.showUrlEwm2 = false
    },
    // 点击忘记密码
    handleFindpaw () {
      this.dialogVisible = true
      this.showUrlEwm1 = true
      this.showUrlEwm2 = false
      this.showUrlEwm = false
    },
    // 点击下一步
    handleNext () {
      let { phone, username } = this.dialogData
      if (!phone || !username) {
        return this.$message({ type: 'warning', message: '请正确填写用户账号和手机号' })
      }

      this.request.post('/front/auth/loginFindPwd', { phone, username }).then(res => {
        if (res.code == 200) {
          this.subData.authId = res.data.id
          this.subData.username = res.data.name
          this.nextLoading = true
          this.request.post('/front/auth/sendCodeToMobilePhone', {tel: this.dialogData.phone}).then(rs => {
            this.nextLoading = false
            if (rs.code == 200) {
              this.showUrlEwm1 = false
              this.showUrlEwm2 = true
              this.second = 60
              this.timmer && clearInterval(this.timmer)
              this.timmer = setInterval(() => {
                this.second--
                if (this.second <= 0) {
                  this.showyzm = false
                  clearInterval(this.timmer)
                }
              }, 1000)
              this.msg.success(rs.msg)
            } else {
              this.msg.error(rs.msg)
            }
          })
        } else {
          this.msg.error(res.msg)
        }
      })
    },
    // 点击重新发送
    handleAgain () {
      this.request.post('/front/auth/sendCodeToMobilePhone', {tel: this.dialogData.phone}).then(res => {
        if (res.code == 200) {
          this.second = 60
          this.showyzm = true
          this.timmer && clearInterval(this.timmer)
          this.timmer = setInterval(() => {
            this.second--
            if (this.second <= 0) {
              this.showyzm = false
              clearInterval(this.timmer);
            }
          }, 1000)
          this.msg.success(res.msg)
        } else {
          this.msg.error(res.msg)
        }
      })
    },
    // 点击修改密码
    handleEnitPwd () {
      if (!textPassword(this.subData.pwd, this)) return

      if (this.subData.pwd === this.subData.pwd1) {
        let par = {
          code: this.subData.code,
          phone: this.dialogData.phone,
          pwd: md5(this.subData.pwd),
          authId: this.subData.authId,
          username: this.subData.username,
        }
        this.enitPwdLoading = true
        this.request.post('/front/auth/changeUserPwd', par).then(res => {
          this.enitPwdLoading = false
          if (res.code == 200) {
            this.msg.success('修改成功')
            this.dialogVisible = false
          } else {
            this.msg.error(res.msg)
          }
        })
      } else {
        this.msg.warn('两次密码不一致，请重新输入')
      }
    },
    handleClosedErweima () {
      this.showUrlEwm = false
    },
    // 弹框关闭触发
    handleClosed () {
      this.dialogData = {
        username: '',
        phone: '',
      }
      this.subData = {
        code: '',
        phone: '',
        pwd: '',
        pwd1: '',
      }
    },
    getSysName() {    //http://10.107.9.13:9002
      this.$axios.get(this.adminUrlAddr+'/admin/config/query').then(res => {
        // console.log(res.data);
        if (res.data.code == 200) {
          let nameItem = res.data.data.filter(item=>item.code=='SYS_NAME')
          this.sysName = nameItem[0].value 
          document.title = nameItem[0].value
        } else if (res.data.code == 500) {
          this.msg.warn(res.data.msg)
          return
        }
      });
    },
    blurPrice () {//失焦事件
     /*  if(this.cookieUser!=''){
      //   console.log(this.userInfo.userName,this.cookieUser);
         if(this.userInfo.userName != this.cookieUser){
            // alert(9999)
            this.userInfo.pwd=""
            this.userInfo.rememberMe=false
            this.clearCookie()
         }
      } */
    },
    validateUserName (rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else if (value.length > 20) {
        callback(new Error("用户名长度不能超过20个字符"));
      } else if (value.length < 2) {
        callback(new Error("用户名长度不能少于2个字符"));
      } else {
        var reg = new RegExp(/^\w+$/);
        if (!reg.test(value)) {
          callback(new Error("用户名不合法"));
        } else {
          callback();
        }
      }
    },
    checkCode () {
      this.request.get("/front/auth/check/code").then((data) => {
        if (data.code == 200) {
          if (data.data != null) {
            this.codeIsShow = true;
            this.codeImg = 'data:image/png;base64,' + data.data;
          }
        }
      });
    },
    rempwd (val) {
      //记住我
      this.userInfo.rememberMe = val;
    },
    /* pwdChange() {
      //密码加密
      this.userInfo.pwd = md5(this.userInfo.pwd);
    }, */
    refreshCode () {
      this.request.get("/front/auth/refresh/vertifycode").then((data) => {
        if (data.code == 200) {
          this.codeImg = "data:image/png;base64," + data.data
        }
      })
    },
    login(formName) {
      //  this.$router.push('/homeIndex')
      //  console.log(this.userInfo.userName)
      //  console.log(this.userInfo.pwd)
      //  console.log(md5(this.userInfo.pwd))
      //  console.log(this.cookieUser)
      //  console.log(this.cookiePwd)
      //  console.log(this.request)      
      //  return
      
     /*  if(this.userInfo.rememberMe == false) {
        this.userInfo.rememberMe = false;
        // console.log("清空Cookie");
        //清空Cookie
        // this.clearCookie();
      }
      if(this.cookieUser != this.userInfo.userName||this.userInfo.pwd != this.cookiePwd){
         // alert(1121)
        if(this.userInfo.pwd.trim()!=''){
         //   alert(444)
            //判断复选框是否被勾选 勾选则调用配置cookie方法
          if (this.userInfo.rememberMe == true) {
            //传入账号名，密码，和保存天数3个参数
            this.setCookie(this.userInfo.userName, md5(this.userInfo.pwd), 7);
          } 
          this.pwdChange();
        }      
      } */
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.checked) {
            return this.$message({ type: 'warning', message: '请先阅读并同意《用户隐私协议》（勾选视为同意协议条款）' })
          }
          let form = {
            username: this.userInfo.userName,
            pwd: md5(this.userInfo.pwd),
            rememberMe: this.userInfo.rememberMe,
          }
          if (this.userInfo.code && this.userInfo.code.trim()) {
            form.code = this.userInfo.code;
          }

          this.logining = true;
          //  console.log(form);
          this.request
            .post("/front/auth/login", form)
            .then((rs) => {
              // console.log(rs);
              if (rs.code == 200) {
                this.msg.success("欢迎登录！");
                let privileges = rs.data.privileges
                
                // this.$cookies.remove("status");
                // this.$cookies.set("status", "logined", 3600);
                this.storage.setSession("orgName", rs.data.orgName);
                this.storage.setSession("orgId", rs.data.orgId);
                // this.storage.setSession("userName", rs.data.username);
                this.storage.setSession("userId", rs.data.userId);
                this.storage.setSession("headImg", rs.data.headImg);
                localStorage.setItem("privileges", privileges);
                this.storage.setSession("login", true);
                this.storage.setSession("rememberMe", this.userInfo.rememberMe);
                // this.storage.setSession("sysStartTime",rs.data.sysStartTime)
                // this.storage.setSession("modelId",rs.data.modelId)
                // this.storage.setSession("readAlarm", false);
                this.storage.setSession("loginName", rs.data.loginName);
                this.storage.setSession("nickName", rs.data.nickName);
                this.storage.setSession("tenant", rs.data.tenant);
                this.storage.setSession("isMaxTenant", rs.data.isMaxTenant);
                sessionStorage.setItem("fixed", rs.data.fixed);
                localStorage.setItem("loginName", rs.data.loginName);

                // 跳转至首页
                // privileges.indexOf('home:show') != -1
                if(rs.data.tenant) {
                  // this.$router.push(`/screen?fixed=${rs.data.fixed}`) // 大屏
                  this.$router.push({ name: 'Screen', params: { fixed: rs.data.fixed } }) // 大屏
                } else {
                  // this.$router.push(`/equipmentM?fixed=${rs.data.fixed}`) // 首页
                  this.$router.push({ name: 'equipmentM', params: { fixed: rs.data.fixed } }) 
                }
              } else if (rs.code == 500) {
                this.msg.error(rs.msg);
                if (rs.data != null) {
                  this.codeIsShow = true;
                  this.codeImg = "data:image/png;base64," + rs.data;
                }
              } else if (rs.code == 1000) {
                this.msg.warn(rs.msg);
              }
              this.logining = false;
            })
            .catch((error) => {
              console.log(error);
              this.logining = false;
            });
        } else {
          this.msg.error("请正确填写用户信息！");
          return false;
        }
      });
    },
    //设置cookie
    /* setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "userPwd" + "=" + c_pwd+ ";path=/;expires=" + exdate.toGMTString();
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.userInfo.userName = arr2[1]; //保存到保存数据的地方
            this.cookieUser = arr2[1]
          } else if (arr2[0] == "userPwd") {
            this.userInfo.pwd = arr2[1];
            this.cookiePwd = arr2[1]
          }
        }
      }
    },
    //清除cookie
    clearCookie: function () {
      this.setCookie("", "", -1); // 修改2值都为空，天数为负1天就好了
    }, */
  },
};

</script>

<style lang="scss" scoped>
.loginFormContainer {
  // width: 350px;
  // height: 410px;
  // background: no-repeat url(../../assets/img/homePage/loginMessBg.png);
  // padding:45px 45px 30px 30px;
  // box-sizing: border-box;
  width: 480px;
  height: 460px;
  position: relative;
  margin: 0 auto;
  // position: absolute;
  // top: 50%;
  // left: 20px;
  // transform: translate(0,-50%);
  .login_bg {
    left: 0;
    padding: 0;
    position: absolute;
    // border: 1px solid #01ABFF;
    width: 480px;
    height: 460px;
    // background: linear-gradient(180deg, rgba(26, 89, 251, 0.13) 0%, #0A39A4 100%);
    // box-shadow:0px 0px 50px 0px #02EAFF inset;
    opacity: 0.2;
    box-sizing: border-box;
  }
  .login_container {
    box-sizing: border-box;
    width: 480px;
    height: 460px;
    position: relative;
    // border: 1px solid red;
    .tip-box {
      // position: absolute;
      // bottom: 80px;
      // left: 12%;
      .tip {
        text-align: center;
        font-size: 13px;
        color: #cacaca;
      }
      .yinsi {
        font-size: 14px;
        color: #01ABFF;
        cursor: pointer;
      }
    }
    .erweima {
      position: absolute;
      top: 40px;
      right: 40px;
      cursor: pointer;
      >img {
        width: 70px;
        height: 70px;
      }
    }
    // padding: 35px 44px 0;
  }
  .selfDialog {
    /deep/.el-dialog {
      // width: 30% !important;
      background-color: transparent;
      .el-dialog__body {
        img {
          width: 100%;
        }
        .findPaw {
          width: 100%;
          height: 500px;
          padding: 70px 45px;
          box-sizing: border-box;
          background: url(../../assets/img/login/tcbg.png) no-repeat;
          background-size: 100% 100%;
          .title {
            text-align: center;
            margin-bottom: 50px;
            h1 {
              color: #06CAE1;
            }
          }
          .title1 {
            color: #fff;
          }
          .dialogForm {
            margin-top: 30px;
            .el-input {
              margin-bottom: 30px;
              .el-input__inner {
                border: 1px solid rgba(0, 255, 255, .4);
                background-color: rgba(7, 67, 93, .4);
                height: 40px;
                color: #fff;
              }
            }
          }
          .buttonNext {
            width: 100%;
            margin-top: 10px;
            .el-button {
              width: 100%;
              height: 50px;
            }
          }
        }
        .findPaw1 {
          width: 100%;
          height: 500px;
          padding: 30px 45px;
          box-sizing: border-box;
          background: url(../../assets/img/login/tcbg.png) no-repeat;
          background-size: 100% 100%;
          .title {
            text-align: center;
            margin-bottom: 50px;
            h1 {
              color: #06CAE1;
            }
          }
          .title1 {
            color: #fff;
          }
          .duanxinYzm {
            display: flex;
            justify-content: space-between;
            margin-top: 30px;
            .yanzhengma {
              width: 70%;
              .el-input {
                .el-input__inner {
                  border: 1px solid rgba(0, 255, 255, .4);
                  background-color: rgba(7, 67, 93, .4);
                  height: 40px;
                  color: #fff;
                }
              }
            }
            .daojishi {
              width: 28%;
              border: 1px solid rgba(0, 255, 255, .4);
              background-color: rgba(7, 67, 93, .4);
              color: #06CAE1;
              text-align: center;
              line-height: 38px;
              border-radius: 3px;
            }
          }
          .dialogForm {
            margin-top: 30px;
            .el-input {
              margin-bottom: 30px;
              .el-input__inner {
                border: 1px solid rgba(0, 255, 255, .4);
                background-color: rgba(7, 67, 93, .4);
                height: 40px;
                color: #fff;
              }
            }
          }
          .buttonNext {
            width: 100%;
            margin-top: 10px;
            .el-button {
              width: 100%;
              height: 50px;
            }
          }
        }
      }
    }
  }
  .loginTitle {
    width: 100%;
    line-height: 30px;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
    position: fixed;
    top: 50%;
    left: 0px;
    margin-top: -310px;
    // border: 1px solid red;
    // height: 60px;
    // line-height: 60px;
    text-align: center;
    // background: no-repeat url(../../assets/img/login/login_tit.png);
    // background-size: 100% 100%;
    // margin-bottom: 40px;
    // padding: 12px;
    span {
      font-size: 38px;
      font-family: Alibaba PuHuiTi;
      color: #FFFFFF;
      letter-spacing: 3px;

      background: linear-gradient(180deg, #D2DEF9 0%, #4AC6D8 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      // font-size: 24px;
      // font-family: PingFangSC-Medium, PingFang SC;
      // font-weight: 500;
      // color: #6EE9FF;
      // letter-spacing: 1px;
      // background: linear-gradient(180deg, #01ABFF 0%, #56DEFE 100%);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }
  }
  .loginForm {
    padding: 30px 60px;
    margin-top: 20px;
    background: url('./../../assets/img/login/bg.png') no-repeat;
    background-size: 100% 100%;
    .welcome-text {
      font-size: 20px;
      color: #06CAE1;
      text-align: center;
      margin: 20px auto;
      animation: letterspacing 2s 1 normal ease-in-out forwards;
    }
    .el-form-item {
      position: relative;
      .codeImg {
        position: absolute;
        width: 30%;
        height: 45px;
        right: 0px;
        top: 0px;
        font-size: 0;
        line-height: 0;
        border-radius: 2px;
        box-sizing: border-box;
        // border: 1px solid #fff;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .loginBtn {
        width: 100%;
        height: 45px;
        // background: linear-gradient(to right, #149FC6, #2E59DB);
        // background: #01ABFF;
        // border-radius: 5px;
        font-size: 18px;
        // font-family: PingFangSC-Medium, PingFang SC;
        // font-weight: 500;
        color: #FFFFFF;
        // letter-spacing: 6px; // 字符间距  导致loading不在圆心转圈
        background: linear-gradient(0deg, #0F50A0, #1DBDFF);
        box-shadow: 0px 1px 1px 0px rgba(0, 66, 146, 0.75);
        border-radius: 4px;
        &:hover {
          background: linear-gradient(0deg, #4594f5, #63caf5);
          // background: linear-gradient(0deg, #084BA2, #1896cb);
          color: #fff;
        }
      }
    }
    .rememberMe {
      text-align: left;
    }
  }
  .yinsi-box {
    // padding: 20px;
    background: #fff;
    font-size: 12px;
    .haveTime {
      text-align: right;
      margin:10px;
    }
    .underline {
      text-decoration: underline;
    }
    .setion {
      height: 500px;
      overflow: auto;
      h2 {
        font-size: 14px;
        margin: 15px 0 8px;
      }
      p {
        line-height: 20px;
        text-indent: 28px;
      }
      .mation {
        font-weight: bold;
        &.first {
          margin-top: 10px;
        }
      }
    }
    .dialog-footer {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
<style lang="scss">
.loginFormContainer {
  .el-form-item {
    margin-bottom: 25px;
    .el-form-item__label {
      display: none;
    }
    .el-form-item__content {
      // margin-left: 0;
      text-align: left;
      position: relative;
      .el-input {
        .el-input__inner {
          font-size: 14px;
          height: 42px;
          line-height: 42px;
          border-radius: 4px;
          border: 1px solid rgba(0, 75, 112, 0.5);
          color: #fff;
          padding-left: 20px;
          // background: rgba(0, 75, 112, 0.5);
          background: rgba(29, 185, 253, .4);
          &::placeholder{
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #01ABFF;
            opacity: 0.6;
          }
        }
        .el-input__prefix {
          left: 14px;
          .inputIcon {
            display: none;
            line-height: 0;
            margin-top: 10px;
            font-size: 0;
            width: 24px;
            height: 24px;
            img {
              width: 100%;
            }
          }
        }
      }
      .codeInput {
        width: 60%;
      }
      .el-checkbox {
        .el-checkbox__input {
          .el-checkbox__inner {
            width: 16px;
            height: 16px;
            border-radius: 4px;
            &::after {
              width: 5px;
              height: 10px;
              left: 6px;
              border-color: #3464e1;
            }
          }
        }
        .is-checked {
          .el-checkbox__inner {
            background: #fff;
            border-color: #fff;
          }
        }
        .el-checkbox__label {
          font-size: 14px;
        }
      }
      .el-button {
        width: 120px;
        height: 42px;
        background: rgba(74, 120, 187, 1);
        border-radius: 8px;
        font-size: 14px;
        color: #fff;
        border:none;
      }
      .forget {
        font-size: 13px;
        position: absolute;
        bottom: 17px;
        right: 0;
        color: #01ABFF;
        cursor: pointer;
      }
    }
  }
  .rememberMe {
    .el-form-item__content {
      height: 24px;
      line-height: 24px;
      .el-checkbox {
        .el-checkbox__input {
          .el-checkbox__inner {
            width: 14px;
            height: 14px;
            border-radius: 2px;
            border: 1px solid #01ABFF;
            background: unset;
            &::after {
              left: 4px;
              top: 0;
            }
          }
        }
        .is-checked {
          .el-checkbox__inner {
            background: no-repeat url(../../assets/img/login/login_select.png);
            background-size: 100% 100%;
            border: none;
            &::after {
              display: none;
            }
          }
        }

        .el-checkbox__label {
          // color: #fff;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #01ABFF;
          // line-height: 22px;
        }
      }
    }
  }
  // .tip-box {
  //   .el-checkbox {
  //     .el-checkbox__input {
  //       .el-checkbox__inner {
  //         width: 14px;
  //         height: 14px;
  //         border-radius: 2px;
  //         border: 1px solid #01ABFF;
  //         background: unset;
  //         &::after {
  //           left: 4px;
  //           top: 0;
  //         }
  //       }
  //     }
  //     .is-checked {
  //       .el-checkbox__inner {
  //         background: no-repeat url(../../assets/img/login/login_select.png);
  //         background-size: 100% 100%;
  //         border: none;
  //         &::after {
  //           display: none;
  //         }
  //       }
  //     }

  //     .el-checkbox__label {
  //       // color: #fff;
  //       font-size: 14px;
  //       font-family: PingFangSC-Medium, PingFang SC;
  //       font-weight: 500;
  //       color: #01ABFF;
  //       // line-height: 22px;
  //     }
  //   }
  // }
  @keyframes letterspacing {
    0% {
      letter-spacing: -2.2rem;
      filter: blur(.3rem);
    }

    50% {
      filter: blur(.5rem);
    }

    100% {
      letter-spacing: .5rem;
      filter: blur(0rem);
    }
  }
}
</style>


